import type { ReactNode } from 'react';

// CB-CONV §7: the design system's Meter (av-meter) and the venue boards' fact tile, built once for
// every page that draws them (the operator's venue design of 2026-10-26). A meter's figure is
// always written beside it, so the bar itself is decoration and hidden from screen readers. Red
// (signal) is for a problem only, as the design system says.

export function Meter({
  label,
  fraction,
  figure,
  signal = false,
}: {
  /** What it measures, before the bar; leave out where a row says it already. */
  label?: ReactNode;
  /** 0 to 1; clamped. */
  fraction: number;
  /** The number, after the bar. */
  figure: ReactNode;
  signal?: boolean;
}) {
  const width = `${Math.round(Math.min(1, Math.max(0, fraction)) * 100)}%`;
  return (
    <div className={`meter ${label !== undefined ? 'meter-labelled' : ''}`}>
      {label !== undefined ? <span>{label}</span> : null}
      <span className={`meter-track ${signal ? 'meter-signal' : ''}`} aria-hidden="true">
        <span className="meter-fill" style={{ width }} />
      </span>
      <span className="meter-figure">{figure}</span>
    </div>
  );
}

/** A fact as a big value over a small uppercase word, with its icon where it has one. */
export function FactTile({
  value,
  label,
  icon,
}: {
  value: ReactNode;
  label: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className="fact-tile">
      {icon ? <span className="fact-tile-icon">{icon}</span> : null}
      <div className="flex flex-col gap-0.5">
        <b>{value}</b>
        <span>{label}</span>
      </div>
    </div>
  );
}
